import { fetcher } from 'utils/axios';
import { dispatch } from 'store';
import { setUserData } from 'store/slices/user';
import { getDataOnLoad } from 'services/dataLoader';
import { requestSystemGlobalBannerRefresh } from 'utils/systemGlobalBannerRefresh';
import {
  APP_ME_BOOTSTRAP_KEY,
  APP_USER_NEEDS_ONBOARDING_KEY,
} from 'utils/auth/sessionBootstrapFlags';
import { stripClerkUserIdPrefix } from 'utils/auth/clerkUserId';
import { submitCampaignAttribution } from 'utils/auth/campaignAttribution';

export type AppUserMeResponse = {
  Udid: string;
  clerkUserId: string;
  companyId: string | null;
  needsOnboarding: boolean;
};

export function markAppMeBootstrapDone(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(APP_ME_BOOTSTRAP_KEY, 'done');
}

export function clearAppMeBootstrap(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(APP_ME_BOOTSTRAP_KEY);
  sessionStorage.removeItem(APP_USER_NEEDS_ONBOARDING_KEY);
}

/**
 * Fetches `/api/users/me`, updates Redux + `localStorage.companyId`, then loads dependent data.
 * Shared by `AuthSync` and post-invite acceptance so the session matches the backend immediately.
 */
export async function loadAppUserProfile(): Promise<AppUserMeResponse | null> {
  const me = (await fetcher('get', '/api/users/me', 'app')) as AppUserMeResponse | null;
  if (!me) {
    return null;
  }

  const udid = stripClerkUserIdPrefix(me.Udid) ?? me.Udid;

  dispatch(
    setUserData({
      CompanyId: me.companyId ?? undefined,
      ...me,
      Udid: udid,
    }),
  );

  if (me.companyId) {
    localStorage.setItem('companyId', me.companyId);
  } else {
    localStorage.removeItem('companyId');
  }

  if (typeof sessionStorage !== 'undefined') {
    if (me.needsOnboarding) {
      sessionStorage.setItem(APP_USER_NEEDS_ONBOARDING_KEY, '1');
    } else {
      sessionStorage.removeItem(APP_USER_NEEDS_ONBOARDING_KEY);
    }
  }

  markAppMeBootstrapDone();

  //* ייחוס קמפיינים: אם נקלטו printid/utm_* במסך הלוגין — נשלחים עכשיו, אחרי אימות מוצלח.
  //* fire-and-forget: כשל כאן לא חוסם את הכניסה (הנתונים יישארו לניסיון הבא).
  void submitCampaignAttribution();

  getDataOnLoad();

  void requestSystemGlobalBannerRefresh({ clearDismiss: false });

  return { ...me, Udid: udid };
}
